import { Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../components/TableContent';
import { NormalizedDistributionProduct } from '../../../../../../store/managementAnalysis/types';
import { DirectTreasuryProductsQueryData } from '../../../../../../store/managementAnalysisDetails/selector';
import { LateralProductBar } from '../../LateralProductBar';

import { tableHead } from './constants';

interface ProductSearchItemProps {
  item: Utils.ArrayElement<NonNullable<DirectTreasuryProductsQueryData>>;
  product: NormalizedDistributionProduct;
}

const ProductSearchItem = ({ item, product }: ProductSearchItemProps) => {
  const getFlex = (index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} py={Spacing['stack.xxs']} px={Spacing['inline.xxxs']}>
      <LateralProductBar backgroundColor={Color[product.color]} />
      <TableContentItemColumn flex={getFlex(0)}>
        <TableContentItemText>{item.customerNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{item.assetNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{item.positionDateNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{item.maturityDateNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText>{item.quantity.toString()}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>{item.positionValueNormalized}</TableContentItemText>
      </TableContentItemColumn>
    </TableContent>
  );
};

export default React.memo(ProductSearchItem);
